import styles from './GalleryImageView.module.scss';

export interface ImageItem {
  src?: string;
  alt?: string;
}

export interface GalleryImageViewProps {
  images?: ImageItem[];
}

export default function GalleryImageView({images}: GalleryImageViewProps) {

  return (
    <div className={styles['image-gallery-container']}>{
      images && images.length > 0 ?
      images?.map((image, index) => (
        <img className={styles['image-gallery-container__item']}key={index} src={image.src} alt={image.alt} />
      )) : <div>No Image</div>
    }</div>
  )
}
